import api from "../../api";
import {typedQuery} from "../typing";

export const verifiedDomains = typedQuery(["verifiedDomains"], async () => {
  return await api.verifiedDomains.list();
});
